var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                ref: "queryCondition",
                staticClass: "searchForm",
                attrs: {
                  "label-width": "120px",
                  model: _vm.queryCondition,
                  "label-position": "right",
                },
              },
              [
                _c(
                  "el-row",
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 24 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { gutter: 20 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    staticClass: "iconStyle",
                                    attrs: {
                                      label: "8位码",
                                      prop: "eightBitCode",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        clearable: "",
                                        type: "textarea",
                                        autosize: { maxRows: 1 },
                                      },
                                      model: {
                                        value:
                                          _vm.queryCondition.eightBitCodeStr,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "eightBitCodeStr",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.eightBitCodeStr",
                                      },
                                    }),
                                    _c("i", {
                                      staticClass: "el-icon-menu",
                                      on: { click: _vm.menuClick },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "8位码名称",
                                      prop: "eightBitCodeName",
                                    },
                                  },
                                  [
                                    _c("el-input", {
                                      staticClass: "handle-input",
                                      staticStyle: { width: "100%" },
                                      attrs: { clearable: "" },
                                      model: {
                                        value:
                                          _vm.queryCondition.eightBitCodeName,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "eightBitCodeName",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "queryCondition.eightBitCodeName",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "提货点",
                                      prop: "tmPickupId",
                                    },
                                  },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        table: "BASE",
                                        field: "PICKUP_POINT",
                                        filterable: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.queryCondition.tmPickupId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "tmPickupId",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.tmPickupId",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { span: 6 } },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "DC", prop: "dcIdList" } },
                                  [
                                    _c("ic-select", {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        filterable: "",
                                        table: "BASE",
                                        field: "DC",
                                        multiple: "",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.queryCondition.dcIdList,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.queryCondition,
                                            "dcIdList",
                                            $$v
                                          )
                                        },
                                        expression: "queryCondition.dcIdList",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-collapse-transition",
                      [
                        _vm.isShow
                          ? _c(
                              "el-col",
                              { attrs: { span: 24 } },
                              [
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "温区",
                                              prop: "temperature",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: { clearable: "" },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .temperature,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "temperature",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.temperature",
                                                },
                                              },
                                              [
                                                _c("el-option", {
                                                  attrs: {
                                                    label: _vm.$t("common.all"),
                                                    value: "",
                                                  },
                                                }),
                                                _vm._l(
                                                  _vm.temperatureList,
                                                  function (item, index) {
                                                    return _c("el-option", {
                                                      key: index,
                                                      attrs: {
                                                        label:
                                                          _vm._f(
                                                            "inputChoiceI18n"
                                                          )(item),
                                                        value: item.code,
                                                      },
                                                    })
                                                  }
                                                ),
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "运输方式",
                                              prop: "transportaionMethod",
                                            },
                                          },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                staticClass: "handle-input",
                                                staticStyle: { width: "100%" },
                                                attrs: {
                                                  filterable: "",
                                                  clearable: "",
                                                },
                                                model: {
                                                  value:
                                                    _vm.queryCondition
                                                      .transportaionMethod,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      _vm.queryCondition,
                                                      "transportaionMethod",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "queryCondition.transportaionMethod",
                                                },
                                              },
                                              _vm._l(
                                                _vm.transportaionMethodList,
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label:
                                                        _vm._f(
                                                          "inputChoiceI18n"
                                                        )(item),
                                                      value: item.code,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _vm.emplFlag == "MCD"
                                          ? _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "承运商",
                                                  prop: "lineSupplierId",
                                                },
                                              },
                                              [
                                                _c("ic-select", {
                                                  staticStyle: {
                                                    width: "100%",
                                                  },
                                                  attrs: {
                                                    table: "BASE",
                                                    field: "CARRIER",
                                                    filterable: "",
                                                    clearable: "",
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.queryCondition
                                                        .lineSupplierId,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.queryCondition,
                                                        "lineSupplierId",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "queryCondition.lineSupplierId",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "非标准线路运费",
                                              prop: "isSpecialFreight",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "COMMON",
                                                field: "YES_NO",
                                                filterable: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .isSpecialFreight,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "isSpecialFreight",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.isSpecialFreight",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "el-row",
                                  { attrs: { gutter: 20 } },
                                  [
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "报价确认时间(从)",
                                              prop: "beginUpdateDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .beginUpdateDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "beginUpdateDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.beginUpdateDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "报价确认时间(至)",
                                              prop: "endUpdateDate",
                                            },
                                          },
                                          [
                                            _c("el-date-picker", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                "value-format": "yyyy-MM-dd",
                                                type: "date",
                                                placeholder:
                                                  _vm.$t("common.selDate"),
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition
                                                    .endUpdateDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "endUpdateDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.endUpdateDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "el-col",
                                      { attrs: { span: 6 } },
                                      [
                                        _c(
                                          "el-form-item",
                                          {
                                            attrs: {
                                              label: "状态",
                                              prop: "status",
                                            },
                                          },
                                          [
                                            _c("ic-select", {
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                table: "COMMON",
                                                field: "DISABLE_ENABLE_CODE",
                                                clearable: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.queryCondition.status,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.queryCondition,
                                                    "status",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "queryCondition.status",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  {
                    attrs: { type: "flex", justify: "center", align: "middle" },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.queryData(1)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("common.search")))]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.restQueryForm },
                      },
                      [_vm._v("重置")]
                    ),
                    _c(
                      "span",
                      {
                        staticClass: "arrowDown",
                        on: {
                          click: function ($event) {
                            _vm.isShow = !_vm.isShow
                          },
                        },
                      },
                      [
                        _vm._v(_vm._s(_vm.isShow ? "收缩" : "展开")),
                        _c("i", {
                          class: _vm.isShow
                            ? "el-icon-arrow-up iconBtn"
                            : "el-icon-arrow-down iconBtn",
                        }),
                      ]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.materialProApplyCreateChangeApply,
                    expression: "materialProApplyCreateChangeApply",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.priceChange()
                  },
                },
              },
              [_vm._v("产品价格变更")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.Product - _vm.freightsExcel,
                    expression: "Product-freightsExcel",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.exportData()
                  },
                },
              },
              [_vm._v("导出")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.Product - _vm.freightsDisable,
                    expression: "Product-freightsDisable",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.prohibited("disable")
                  },
                },
              },
              [_vm._v("运费禁用")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.Product - _vm.freightsDisable,
                    expression: "Product-freightsDisable",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.prohibited("enable")
                  },
                },
              },
              [_vm._v("运费启用")]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.send_product_freight_to_mdm,
                    expression: "send_product_freight_to_mdm",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: {
                  click: function ($event) {
                    return _vm.sendToMDM()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("base.productFreight.sendToMDM")))]
            ),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "acl",
                    rawName: "v-acl",
                    value: _vm.MaintainCarrierDeliveryType,
                    expression: "MaintainCarrierDeliveryType",
                  },
                ],
                staticClass: "btn",
                attrs: { size: "mini", type: "primary" },
                on: { click: _vm.deliveryTypeFunc },
              },
              [_vm._v("配送类型")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            ref: "tableDetailRef",
            attrs: {
              data: _vm.tableDetail,
              "row-key": "tmProductFreightId",
              border: "",
              "max-height": "600",
              "highlight-current-row": "",
            },
            on: { "selection-change": _vm.findCarrierCode },
          },
          [
            _c("el-table-column", {
              attrs: {
                sortable: "",
                "reserve-selection": "",
                type: "selection",
                width: "55",
                align: "center",
                fixed: "",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "eightBitCode",
                label: "8位码",
                "min-width": "70px",
                fixed: "",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "eightBitCodeName",
                label: "8位码名称",
                "min-width": "130px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "tmPickupId",
                label: "提货点",
                "min-width": "90px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.tmPickupId,
                            "BASE",
                            "PICKUP_POINT"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "tmDcId",
                label: "到货仓库（DC）",
                "min-width": "130px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(_vm._f("ic")(scope.row.tmDcId, "BASE", "DC"))
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "temperature",
                label: "温区",
                "min-width": "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.temperature,
                            "COMMON",
                            "TEMPERATURE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "transportaionMethod | ic('COMMON','TRANSPORTAION_METHOD')",
                label: "运输方式",
                "min-width": "90px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.transportaionMethod,
                            "COMMON",
                            "TRANSPORTAION_METHOD"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "productPrice",
                label: _vm.$t("base.productFreight.productPrice"),
                "min-width": "150px",
                "header-align": "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "effectiveBeginDate",
                label: "产品有效开始日期",
                width: "150",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.effectiveBeginDate,
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "futureProductPrice",
                label: _vm.$t("base.productFreight.futureProductPrice"),
                "min-width": "180px",
                "header-align": "center",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "futureEffectiveBeginDate",
                label: "未来产品有效开始日期",
                width: "170px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("dateFormatFilter")(
                            scope.row.futureEffectiveBeginDate,
                            "YYYY-MM-DD"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "linePrice",
                label: "线路价格",
                "min-width": "90px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "lineUnit",
                label: "结算单位",
                "min-width": "90px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(scope.row.lineUnit, "COMMON", "UNIT")
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "lineSupplierId",
                label: "线路承运商",
                "min-width": "100px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.lineSupplierId,
                              "BASE",
                              "CARRIER"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "tmSupplier",
                label: "8位码供应商",
                "min-width": "170",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("ic")(
                              scope.row.tmSupplierId,
                              "BASE",
                              "SUPPLIER"
                            )
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "eightBitCodePlantName",
                label: "8位码工厂",
                "min-width": "170",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "isSpecialFreight",
                label: "非标准线路运费",
                "min-width": "140px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.isSpecialFreight,
                            "COMMON",
                            "YES_NO"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "externalPackagingLength",
                label: "外包装长(cm)",
                "min-width": "120px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "externalPackagingWidth",
                label: "外包装宽(cm)",
                "min-width": "120px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "externalPackagingHeight",
                label: "外包装高(cm)",
                "min-width": "120px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "externalPackagingNetweight",
                label: "外包装净重(kg)",
                "min-width": "130px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "externalPackagingGrossweight",
                label: "外包装毛重(kg)",
                "min-width": "130px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "palletItemsLength",
                label: "托盘上物品长度(cm)",
                "min-width": "150px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "palletItemsWidth",
                label: "托盘上物品宽度(cm)",
                "min-width": "150px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "palletItemsHeight",
                label: "托盘上物品高度(cm)",
                "min-width": "150px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "palletLayerNumber",
                label: "每Pallet层数",
                "min-width": "110px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "palletLayerBoxNumber",
                label: "每层箱数",
                "min-width": "90px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "status",
                label: "状态",
                "min-width": "80px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(
                          _vm._f("ic")(
                            scope.row.status,
                            "COMMON",
                            "DISABLE_ENABLE_CODE"
                          )
                        )
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "remarks",
                label: _vm.$t("common.remarks"),
                "min-width": "100px",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                prop: "updateDate",
                label: _vm.$t("base.productFreight.updateDate"),
                "min-width": "120px",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _vm._v(
                        _vm._s(_vm._f("dateFormatFilter")(scope.row.updateDate))
                      ),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                sortable: "",
                align: "center",
                label: _vm.$t("base.linePrice.operation"),
                "min-width": "100px",
                fixed: "right",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-link",
                        {
                          directives: [
                            {
                              name: "acl",
                              rawName: "v-acl",
                              value: _vm.Product - _vm.freightsHistories,
                              expression: "Product-freightsHistories",
                            },
                          ],
                          attrs: { type: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.getFistories(scope.row)
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("base.linePrice.history")))]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: {
                "current-page": _vm.queryCondition.pageNum,
                "page-sizes": _vm.pageSizeList,
                "page-size": _vm.queryCondition.pageSize,
                layout: _vm.pageLayout,
                total: _vm.totalCount,
              },
              on: {
                "size-change": _vm.pageSizeChange,
                "current-change": _vm.pageNumberChange,
              },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.showSelDcMultipleDialog,
              "append-to-body": "",
              width: "80%",
            },
            on: {
              "update:visible": function ($event) {
                _vm.showSelDcMultipleDialog = $event
              },
            },
          },
          [
            _c("SelDc", {
              ref: "selectDcMultipleRef",
              attrs: { multipleSelectionFlag: false },
              on: { subCallMethod: _vm.selectDcMethod },
            }),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            attrs: {
              visible: _vm.dialogTableVisible,
              width: "40%",
              "close-on-click-modal": false,
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogTableVisible = $event
              },
            },
          },
          [
            _vm.dialogTableVisible
              ? _c("dialog-table", { attrs: { gridData: _vm.gridData } })
              : _vm._e(),
          ],
          1
        ),
        _c(
          "el-dialog",
          {
            staticClass: "fpa",
            attrs: {
              title: "配置配送类型",
              visible: _vm.dialogDeliveryTypeVisible,
              width: "40%",
              "close-on-click-modal": false,
              "append-to-body": "",
            },
            on: {
              "update:visible": function ($event) {
                _vm.dialogDeliveryTypeVisible = $event
              },
            },
          },
          [
            _c(
              "el-row",
              { staticStyle: { "margin-bottom": "8px" } },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onAdd },
                  },
                  [_vm._v("新增新的物流服务商")]
                ),
              ],
              1
            ),
            _c(
              "el-form",
              {
                ref: "deliveryTypeForm",
                attrs: { model: _vm.deliveryTypeForm },
              },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.deliveryTypeForm.deliveryTypeData,
                      "max-height": "400px",
                      border: "",
                      stripe: "",
                    },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { label: "操作", width: "80px" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              scope.row.carrierCode !== "OTHER"
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onDelete(
                                            scope.row,
                                            scope.$index
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("删除")]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "carrierCode", label: "物流服务商" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: `deliveryTypeData.${scope.$index}.carrierCode`,
                                    rules: _vm.carrierCodeRules(
                                      scope.$index,
                                      scope.row
                                    ),
                                  },
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        disabled:
                                          scope.row.carrierCode == "OTHER",
                                      },
                                      on: {
                                        change: function ($event) {
                                          return _vm.carrierCodeChange(
                                            $event,
                                            scope.$index
                                          )
                                        },
                                      },
                                      model: {
                                        value: scope.row.carrierCode,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            scope.row,
                                            "carrierCode",
                                            $$v
                                          )
                                        },
                                        expression: "scope.row.carrierCode",
                                      },
                                    },
                                    _vm._l(
                                      _vm.carrierCodeLists,
                                      function (item, index) {
                                        return _c("el-option", {
                                          key: index,
                                          attrs: {
                                            value: item.supplierCode,
                                            label: item.supplierName,
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                    _c("el-table-column", {
                      attrs: { prop: "deliveryType", label: "配送类型" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    prop: `deliveryTypeData.${scope.$index}.deliveryType`,
                                    rules: _vm.deliveryTypeRules(
                                      scope.$index,
                                      scope.row
                                    ),
                                  },
                                },
                                [
                                  _c("ic-select", {
                                    staticStyle: { width: "100%" },
                                    attrs: {
                                      table: "TT_CARRIER_DELIVERY_TYPE",
                                      field: "DELIVERY_TYPE",
                                      clearable: "",
                                    },
                                    model: {
                                      value: scope.row.deliveryType,
                                      callback: function ($$v) {
                                        _vm.$set(scope.row, "deliveryType", $$v)
                                      },
                                      expression: "scope.row.deliveryType",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "el-row",
              {
                staticStyle: { "margin-top": "8px" },
                attrs: { gutter: 10, type: "flex", justify: "center" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onConfirm },
                  },
                  [_vm._v("确定")]
                ),
                _c(
                  "el-button",
                  {
                    staticClass: "btn",
                    attrs: { size: "mini", type: "primary" },
                    on: { click: _vm.onCancel },
                  },
                  [_vm._v("取消")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }